import React from "react";
import "./infoCard.scss";

const InfoCard = ({ title, img, desc, clickAction, className = "" }) => {
  return (
    <div
      className={`card bg-white infoCard d-flex align-items-center ${className}`}
      onClick={clickAction}
      title={className === "enabled" ? `${title} Report` : "Not Supported"}
    >
      <div className="card-img">{img}</div>
      <div className="card-title">{title}</div>
      <div className="card-desc">{desc}</div>
    </div>
  );
};

export default InfoCard;
